// we define the possible variables as an object and infer the type from it, so we have the possible keys at runtime to filter invalid stuff
// from the several sources we consume (default JSON, API...)
const skinConfigObj = {
  _dark_grey: "",
  _medium_grey: "",
  _light_grey: "",
  _medium_grey_outline: "",
  _medium_grey_background: "",
  _light_grey_background: "",
  _bright: "",
  _dark: "",
  _cyan: "",
  dark_mode_color: "",
  dark_mode_color_intensity: "",
  dark_mode_cta_button_background_color: "",
  _dark_background_color: "",
  _darker_background_color: "",
  _brighter_background_color: "",
  _even_brighter_background_color: "",
  _dark_border_color: "",
  _text_on_darkcolor: "",
  _label_color: "",
  _status_grey: "",
  _clickarea_bg_highlight: "",
  _clickarea_bg_hover: "",
  accent_color: "",
  background_data: "",
  background_size: "",
  button_color: "",
  button_color_disabled: "",
  button_color_disable_overlay: "",
  button_hover_color: "",
  checklist_button_background: "",
  checklist_button_hover_border_color: "",
  color_orange: "",
  color_red: "",
  cta_button_background_color: "",
  cta_button_background_color_disabled: "",
  cta_button_background_color_hover: "",
  cta_button_color: "",
  dimmer_backdrop_filter: "",
  dimmer_color: "",
  favicon_data: "",
  header_background_color: "",
  header_form_background_color: "",
  header_form_placeholder_color: "",
  header_form_color: "",
  headlines_color: "",
  h1_color: "",
  h2_color: "",
  h3_color: "",
  h4_color: "",
  h5_color: "",
  h6_color: "",
  high_contrast_border: "",
  high_contrast_border_width: "",
  high_contrast_border_style: "",
  high_contrast_border_color: "",
  icons_color: "",
  icons_darker_color: "",
  ig_box_shadow: "",
  ig_box_shadow_color: "",
  ig_box_shadow_blur: "",
  box_shadow: "",
  box_glow: "",
  ig_color_accordion_header_background: "",
  ig_color_accordion_header_foreground: "",
  ig_color_accordion_header_hover_background: "",
  ig_color_accordion_header_active_background: "",
  ig_color_accordion_header_active_foreground: "",
  ig_color_alert_error_background: "",
  ig_color_alert_error_foreground: "",
  ig_color_alert_info_background: "",
  ig_color_alert_info_foreground: "",
  ig_color_alert_success_background: "",
  ig_color_alert_success_foreground: "",
  ig_color_alert_warning_background: "",
  ig_color_alert_warning_foreground: "",
  ig_color_billing_invoice_info_foreground: "",
  ig_color_box_shadow: "",
  ig_color_black: "",
  ig_color_breadcrumb_foreground: "",
  ig_color_card_background: "",
  ig_color_card_background_hover: "",
  ig_color_card_border: "",
  ig_color_card_label: "",
  ig_color_checklist_green_background: "",
  ig_color_checklist_green_foreground: "",
  ig_color_coral_red_hover: "",
  ig_color_coral_red: "",
  ig_color_coral_red40: "",
  ig_color_coral_red60: "",
  ig_color_dashboard_connection_lines: "",
  ig_color_dashboard_object_names: "",
  ig_color_designer_preview_outline: "",
  ig_color_details_header_headline: "",
  ig_color_dropdown_group_header_background: "",
  ig_color_dropdown_group_header_foreground: "",
  ig_color_emptystate_icon: "",
  ig_color_emptystate_text: "",
  ig_color_empty_state_add_button_background: "",
  ig_color_empty_state_add_button_foreground: "",
  ig_color_form_clickarea_background_highlight: "",
  ig_color_form_clickarea_background_hover: "",
  ig_color_form_clickarea_background: "",
  ig_color_form_clickarea_foreground_bold_highlight: "",
  ig_color_form_clickarea_foreground_bold: "",
  ig_color_form_clickarea_foreground_light_highlight: "",
  ig_color_form_clickarea_foreground_light: "",
  ig_color_form_dropdown_placeholder: "",
  ig_color_form_dropdown_selected: "",
  ig_color_form_input_background: "",
  ig_color_form_input_foreground: "",
  ig_color_form_input_placeholder_foreground: "",
  ig_color_form_input_switch_background_off: "",
  ig_color_form_input_switch_background_on: "",
  ig_color_form_input_switch_handle_off: "",
  ig_color_form_input_switch_handle_on: "",
  ig_color_form_label_color: "",
  ig_color_header_borders: "",
  ig_color_header_icon_background: "",
  ig_color_header_icon_foreground: "",
  ig_color_helpcenter_bullet_background: "",
  ig_color_helpcenter_bullet_foreground: "",
  ig_color_helpcenter_header_gradient_from: "",
  ig_color_helpcenter_header_gradient_to: "",
  ig_color_hint_orange: "",
  ig_color_hint_orange40: "",
  ig_color_label: "",
  ig_color_label2: "",
  ig_color_label_light: "",
  ig_color_light_blue: "",
  ig_color_list_value: "",
  ig_color_main_menu_background: "",
  ig_color_main_menu_foreground: "",
  ig_color_main_menu_active_background: "",
  ig_color_main_menu_active_foreground: "",
  ig_color_main_menu_hover_background: "",
  ig_color_side_menu_background: "",
  ig_color_side_menu_foreground: "",
  ig_color_side_menu_active_background: "",
  ig_color_side_menu_active_foreground: "",
  ig_color_side_menu_hover_background: "",
  ig_color_medium_blue_hover: "",
  ig_color_medium_blue: "",
  ig_color_medium_blue20: "",
  ig_color_medium_blue40: "",
  ig_color_medium_blue60: "",
  ig_color_menu_background: "",
  ig_color_menu_background_highlight: "",
  ig_color_menu_background_hover: "",
  ig_color_menu_background_project_switch_hover: "",
  ig_color_menu_foreground: "",
  ig_color_menu_foreground_highlight: "",
  ig_color_menu_foreground_light: "",
  ig_color_midnight_blue: "",
  ig_color_note_yellow: "",
  ig_color_overlay_alert_close_button_background: "",
  ig_color_overlay_alert_close_button_foreground: "",
  ig_color_overlay_alert_dimmer: "",
  ig_color_overlay_alert_message: "",
  ig_color_more_icon_foreground: "",
  ig_color_more_icon_hover_background: "",
  ig_color_more_icon_hover_foreground: "",
  ig_color_pitch_black: "",
  ig_color_price_table_border: "",
  ig_color_price_table_foreground_bold: "",
  ig_color_price_table_foreground: "",
  ig_color_price_table_header_background: "",
  ig_color_price_table_header_foreground: "",
  ig_color_price_list_header_background: "",
  ig_color_price_list_header_foreground: "",
  ig_color_price_list_header_foreground_bold: "",
  ig_color_progressbar_background: "",
  ig_color_sky_blue_hover: "",
  ig_color_sky_blue: "",
  ig_color_sky_blue20: "",
  ig_color_sky_blue40: "",
  ig_color_sky_blue60: "",
  ig_color_status_grey: "",
  ig_color_success_green_hover: "",
  ig_color_success_green_light: "",
  ig_color_success_green: "",
  ig_color_success_green40: "",
  ig_color_text: "",
  ig_color_text_darker: "",
  ig_color_tooltip_background: "",
  ig_color_tooltip_foreground: "",
  ig_color_tooltip_shadow: "",
  ig_color_viewport_background: "",
  ig_color_warning_red_light: "",
  ig_color_warning_red: "",
  ig_color_warning_red40: "",
  ig_color_white: "",
  ig_color_white80: "",
  ig_color_white40: "",
  ig_color_white30: "",
  ig_color_hotspot: "",
  ig_menu_overlay_box_shadow: "",
  ig_text_color: "",
  input_checkbox_border: "",
  input_form_border: "",
  invert_buttons: false,
  invert_header_items: false,
  invert_header: false,
  invert_pricebox_button: "",
  link_color: "",
  link_color_hover: "",
  login_button_color: "",
  login_icon_headline_color: "",
  logo_data: "",
  logo_dark_data: "",
  logo_width: "",
  logo_dark_width: "",
  menu_link_color: "",
  price_box_button_background: "",
  price_box_button_background_disabled: "",
  price_box_button_background_hover: "",
  pricebox_color_background: "",
  pricebox_color: "",
  pricebox_border_color: "",
  primary_color: "",
  primary_color_darker20: "",
  primary_color_hover: "",
  primary_color_rgba10: "",
  primary_color_rgba20: "",
  primary_color_rgba30: "",
  primary_color_rgba40: "",
  primary_color_rgba50: "",
  primary_color_rgba60: "",
  primary_color_rgba70: "",
  primary_color_rgba80: "",
  primary_color_rgba90: "",
  primary_dark_color: "",
  primary_darker_color: "",
  primary_text_color: "",
  rounded_icon_background_active: "",
  rounded_icon_background_inactive: "",
  rounded_icon_color_active: "",
  rounded_icon_color_inactive: "",
  secondary_color: "",
  secondary_text_color: "",
  skin_font_family_headline: "",
  skin_font_family: "",
  skin_name: "",
  table_cell_action_icon_color: "",
  table_cell_background_color: "",
  table_cell_background_color_hover: "",
  table_cell_modal_background_color: "",
  table_cell_modal_background_color_hover: "",
  table_cell_foreground_color: "",
  table_cell_link_foreground_color: "",
  table_cell_border_default: "",
  table_cell_border_group: "",
  table_header_background_color: "",
  table_header_checkbox_border_color: "",
  table_header_border_color: "",
  table_header_font_color: "",
  table_selected_actions_link_color: "",
  table_selected_actions_hover_backgroundcolor: "",
  table_selected_actions_label: "",
  text_secondary_color: "",
};

export type BASE_COLOR_OPTION = 'var(--primary-color)' | '$secondaryColor' | '$accentColor' | 'var(--primary-text-color)' | '$primaryDarkColor' | '$igColorWhite';
export const skinConfigProperties = Object.keys(skinConfigObj);
export type SkinConfigValueSassFunction = {
  "sass-function": "color.scale" | "rgba" | "darken" | "lighten" | 'adjust-hsl',
  "sass-function-args": SkinConfigValue[]
};
export type SkinConfigValueIf = {
  if: string;
  then: string;
  else: string;
};
export type SkinConfigValue = undefined | number | string | boolean | SkinConfigValueSassFunction | SkinConfigValueIf;
export type SkinConfig = Partial<Record<keyof typeof skinConfigObj, SkinConfigValue>>;
